import React, { useEffect } from 'react'
import { Box, CardHeader, Typography, Button } from '@mui/material'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import RouterHook from '../../../contexts/RouterHook'
import { IoChevronBack } from 'react-icons/io5'
import { useLocation } from 'react-router-dom'
import { Loading } from '../../Simple'
import { CancelarDiaria } from '../../Modais'
import useDetalhesDiaria from './Diaria.functions.ts'
import { CompError } from '../../Complex/index.js'
import moment from 'moment'

import { stMob } from './styles'

export default function DiariaMob() {
  const location = useLocation()
  const serveRouter = RouterHook()

  const { sttCtxAgend, loadAgend, actionsDiaria, modaisAgend } =
    React.useContext(AgendamentoContext)
  const { verificarAcessoUsuario, BuscarDiariaId, semAcesso } = useDetalhesDiaria()

  useEffect(() => {
    const idcompraDayuse = location.pathname.split('/').pop()
    BuscarDiariaId(idcompraDayuse).then(diaria => {
      verificarAcessoUsuario(diaria)
    })
  }, [])

  function ReturnColorStt() {
    if (sttCtxAgend.diariaSel?.status === 'SOLICITADA') {
      return '#ff7043'
    } else if (sttCtxAgend.diariaSel?.status === 'AGENDADA') {
      return '#22ac4a'
    } else if (sttCtxAgend.diariaSel?.status === 'CANCELADA') {
      return '#bf3324'
    } else if (sttCtxAgend.diariaSel?.status === 'REALIZADA') {
      return '#00cda4'
    }
  }

  function RetornaRegraCancelamento() {
    if (sttCtxAgend.diariaSel?.dayuse.usuarioPodeCancelar === 'SEMPRE') {
      return 'A qualquer momento'
    } else if (sttCtxAgend.diariaSel?.dayuse.usuarioPodeCancelar === 'DIA') {
      return 'Até 24 horas antes'
    } else if (sttCtxAgend.diariaSel?.dayuse.usuarioPodeCancelar === 'NAO') {
      return 'Não poderá cancelar'
    }
  }

  return (
    <>
      {modaisAgend.cancelamentoDiaria && (
        <CancelarDiaria
          show={modaisAgend.cancelamentoDiaria}
          onClose={() => actionsDiaria.handleModaisAgend('cancelamentoDiaria', false)}
        />
      )}
      {loadAgend.diaria ? (
        <div className='contain-loading'>
          <Loading text={'Carregando diária...'} />
        </div>
      ) : semAcesso ? (
        <CompError
          title='Diária não encontrada'
          message='A diária que você está tentando acessar não foi encontrada.'
        />
      ) : (
        <div className='contain-page-mobile'>
          <CardHeader
            avatar={
              <IoChevronBack size={25} color={'#ff7043'} onClick={() => serveRouter('back')} />
            }
            title={
              <Typography variant='h5' sx={stMob.titlePage}>
                Diária
              </Typography>
            }
            subheader={
              <Typography
                variant='h6'
                sx={stMob.subTitlePage}
              >{`Nº #${location.pathname.split('/').pop()}`}</Typography>
            }
          />
          <Box sx={stMob.containDetailsDiaria}>
            <Box sx={stMob.containDetailsBorder}>
              <Typography variant='h6' sx={stMob.subTitleComp}>
                Detalhes
              </Typography>
              <Box sx={stMob.containLineComp}>
                <Typography variant='h6' sx={stMob.textLabelComp}>
                  Nome
                </Typography>
                <Typography variant='h6' sx={stMob.textDescComp}>
                  {sttCtxAgend.diariaSel?.dayuse.titulo}
                </Typography>
              </Box>
              <Box sx={stMob.containLineComp}>
                <Typography variant='h6' sx={stMob.textLabelComp}>
                  Data
                </Typography>
                <Typography variant='h6' sx={stMob.textDescComp}>
                  {moment(sttCtxAgend.diariaSel?.data).format('dddd, DD/MM/YYYY')}
                </Typography>
              </Box>
              <Box sx={stMob.containLineComp} marginBottom={1}>
                <Typography variant='h6' sx={stMob.textLabelComp}>
                  Situação
                </Typography>
                <Typography variant='h6' sx={{ ...stMob.textDescComp, color: ReturnColorStt() }}>
                  {sttCtxAgend.diariaSel?.status}
                </Typography>
              </Box>
            </Box>
            <Box sx={stMob.containDetailsBorder}>
              <Typography variant='h6' sx={stMob.subTitleComp}>
                Regras
              </Typography>
              <Box sx={stMob.containLineComp}>
                <Typography variant='h6' sx={stMob.textLabelComp}>
                  Cancelamento
                </Typography>
                <Typography variant='h6' sx={stMob.textDescComp}>
                  {RetornaRegraCancelamento()}
                </Typography>
              </Box>
              <Box sx={stMob.containLineComp}>
                <Typography variant='h6' sx={stMob.textLabelComp}>
                  Duração
                </Typography>
                <Typography variant='h6' sx={stMob.textDescComp}>
                  {sttCtxAgend.diariaSel?.dayuse.duracao}
                </Typography>
              </Box>
              <Box sx={stMob.containLineComp} marginBottom={1}>
                <Typography variant='h6' sx={stMob.textLabelComp}>
                  Quadra
                </Typography>
                <Typography variant='h6' sx={stMob.textDescComp}>
                  {sttCtxAgend.diariaSel?.dayuse.quadra}
                </Typography>
              </Box>
            </Box>
            <Box sx={stMob.containDetailsBorder}>
              <Typography variant='h6' sx={stMob.subTitleComp}>
                Pagamento
              </Typography>
              <Box sx={stMob.containLineComp}>
                <Typography variant='h6' sx={stMob.textLabelComp}>
                  Forma de pagamento
                </Typography>
                <Typography variant='h6' sx={stMob.textDescComp}>
                  {sttCtxAgend.diariaSel?.formaPagamento}
                </Typography>
              </Box>
              <Box sx={stMob.containLineComp}>
                <Typography variant='h6' sx={stMob.textLabelComp}>
                  Total
                </Typography>
                <Typography variant='h6' sx={stMob.textDescComp}>
                  {`R$ ${sttCtxAgend.diariaSel?.valorTotal.toFixed(2).toString().replace('.', ',')}`}
                </Typography>
              </Box>
            </Box>
            <Box sx={stMob.containImagem}>
              <Typography variant='h6' sx={stMob.titleImagem}>
                {sttCtxAgend.diariaSel?.dayuse.empresa.nome}
              </Typography>
              <img
                src={
                  sttCtxAgend.diariaSel?.dayuse.empresa.urlFoto +
                  sttCtxAgend.diariaSel?.dayuse.empresa.foto
                }
                alt='Imagem do Dayuse'
                style={stMob.imgContain}
              />
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ py: 3 }}>
              <div
                className='rtz-banner'
                data-rtz-espaco-id='120'
                style={{ width: '320px', height: '100px', overflow: 'hidden' }}
                data-rtz-width='320'
                data-rtz-height='100'
                title='Espaço publicitário'
                data-rtz-display-formato='imagem_video'
                data-rtz-tipo-criativo='360'
                data-rtz-device='mobile'
              ></div>
            </Box>
            {((sttCtxAgend.diariaSel?.status === 'SOLICITADA' &&
              sttCtxAgend.diariaSel?.formaPagamento !== 'PIX') ||
              sttCtxAgend.diariaSel?.status === 'AGENDADA') && (
              <Button
                fullWidth
                variant='contained'
                color='primary'
                onClick={() => {
                  actionsDiaria.handleModaisAgend('cancelamentoDiaria', true)
                }}
              >
                Cancelar
              </Button>
            )}
          </Box>
        </div>
      )}
    </>
  )
}
